import React from "react";
import { Card, Image } from "antd";
import SignedLinkWrapper from "@/components/SignedLinkWrapper";
import style from "./style.less";

const ImagesGrid = ({ title, images }) => {
  return (
    <Card title={title} bordered={false} id={style.vehicleImagesGrid}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(auto, 200px) minmax(auto, 200px) minmax(auto, 200px)",
          justifyContent: "center",
          columnGap: "10px",
          rowGap: "10px",
        }}
      >
        {!images?.length ? (
          "No images"
        ) : (
          <Image.PreviewGroup>
            {images.map(image => (
              <SignedLinkWrapper key={image.id} privateUrl={image.url}>
                {signedUrl => <Image src={signedUrl} alt="Vehicle Image" style={{ maxWidth: 200 }} />}
              </SignedLinkWrapper>
            ))}
          </Image.PreviewGroup>
        )}
      </div>
    </Card>
  );
};

export default ImagesGrid;
